import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  CardStyle,
  getRichLinkCardStyle,
  LinkCardShape,
} from 'shared/utils/CardStyleUtil';

interface DovetaleLoadingProductLinkCardProps {
  style: CardStyle;
}

export const DovetaleLoadingProductLinkCard = ({
  style,
}: DovetaleLoadingProductLinkCardProps) => {
  return (
    <div
      className={classNames(
        'flex',
        'w-full',
        'rounded',
        'bg-white',
        'shadow',
        'p-1',
        'gap-4',
      )}
      style={getRichLinkCardStyle(style)}
      role="button"
    >
      <div className={classNames('w-1/3', 'flex-col')}>
        <div
          className={classNames(
            'relative',
            {
              'rounded-sm': style.linkCardShape !== LinkCardShape.RoundedLarge,
              'rounded-[1.125rem]':
                style.linkCardShape === LinkCardShape.RoundedLarge,
            },
            'leading-none',
            'aspect-[121/104]',
          )}
        >
          <Skeleton height="100%" />
        </div>
      </div>

      <div
        className={classNames(
          'flex-1',
          'flex',
          'flex-col',
          'justify-evenly',
          'text-sm',
        )}
      >
        <Skeleton width={180} />
        <p
          className={classNames(
            'hidden',
            'sm:line-clamp-3',
            '[word-break:normal]',
            '[overflow-wrap:anywhere]',
          )}
        >
          <Skeleton count={2} width="80%" />
        </p>

        <Skeleton width={60} />
      </div>
    </div>
  );
};
